import React from 'react';
import '../styles/WorkflowStatus.css';

function WorkflowStatus({ loading, error, data, fetchData }) {
    return (
        <div>
            <h1>Pointr GitHub Workflows Status</h1>
            {loading ? (
                <p>Loading workflows...</p>
            ) : error ? (
                <div>
                    <div className="button-container">
                        <button onClick={fetchData}>Refresh Dashboard Data</button>
                    </div>
                    <p style={{color: "red"}}>{error}</p>
                </div>
            ) : data.length > 0 ? (
                <div>
                    <div className="button-container">
                        <button onClick={fetchData}>Refresh Dashboard Data</button>
                    </div>
                    <div id="workflows-dashboard">
                    {data.map((repo) => (
                        <div key={repo.repoName}>
                            <h3>{repo.repoName}</h3>
                            <table>
                                <thead>
                                <tr>
                                    <th>Workflow Name</th>
                                    <th>Status</th>
                                    <th>Conclusion</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Actor</th>
                                    <th>Run Attempt</th>
                                    <th>Details</th>
                                </tr>
                                </thead>
                                <tbody>
                                {repo.workflows.map((workflow) => (
                                    <tr key={workflow.id}>
                                        <td>{workflow.name}</td>
                                        <td>{workflow.status}</td>
                                        <td>{workflow.conclusion}</td>
                                        <td>{new Date(workflow.createdAt).toLocaleString()}</td>
                                        <td>{new Date(workflow.updatedAt).toLocaleString()}</td>
                                        <td>{workflow.actor}</td>
                                        <td>{workflow.runAttempt}</td>
                                        <td>
                                            <a href={workflow.htmlUrl} target="_blank" rel="noopener noreferrer">
                                                View Details
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    ))}
                    </div>
                </div>
            ) : (
                <p>No data available.</p>
            )}
        </div>
    );
}

export default WorkflowStatus;
